function cambiarPagina(pagina) {
    // Actualizar la URL con el nuevo número de página
    window.location.href = "?pagina=" + pagina;
}


